import { useRef } from 'react'

import Lottie, { LottieRefCurrentProps } from 'lottie-react'

import { useRegistToSequentialList } from '@web/libs/sequential'
import Place_Particleblue from '@web/pages/mission/modal/lottie/Place_Particleblue.json'

interface Props {
  order: number
  delaySeconds?: number
  className?: string
}
const ParticleAnimation = ({ order, delaySeconds = 0.8, className }: Props) => {
  const particleRef = useRef<LottieRefCurrentProps>(null)

  useRegistToSequentialList({
    order,
    onExecute: () => {
      particleRef.current?.playSegments([0, 121], true)
    },
    type: 'withPrev',
    delaySeconds,
    durationSeconds: 2,
    id: `particle-${order}`,
  })

  return (
    <Lottie
      className={className}
      lottieRef={particleRef}
      autoplay={false}
      loop={false}
      initialSegment={[121, 121]}
      animationData={Place_Particleblue}
    />
  )
}

export default ParticleAnimation
